'use strict'

import React, { useEffect, useState } from 'react'

function PropertyFilter (props) {
  //console.info(props)
  const [opened, setOpened] = useState(true)

  const checkboxes = () => {
    let list = []

    for (let key in props.values) {
      //console.info(value)
      list.push(<div className={'checkbox'} key={key}>
        <label>
        <span className={'input-checkbox'}>
          <input type={'checkbox'} name={id} value={key} onChange={props.onChange}/>
          <span className="checkbox-text">
              <span>{key}</span>&nbsp;<span className="count">{`(${props.values[key]})`}</span>
          </span>
        </span>
        </label>
      </div>)
    }

    return list
  }

  const id = props.hasOwnProperty('id') ? props.id : props.hasOwnProperty('name') ? props.name : 'undefined'
  const title = props.hasOwnProperty('title') ? props.title : props.hasOwnProperty('name') ? props.name : 'undefined'

  return (
    <div className={`filter-box ${opened ? 'active' : ''}`}>
      <div className={'filter-box__title'} onClick={() => (setOpened(!opened))}>{title}</div>
      <div className={`filter-box__container ${!opened ? 'collapsed' : ''}`}>
        <ul className={'filter-items-list'}>
          {checkboxes()}
        </ul>
      </div>
    </div>
  )
}

export default PropertyFilter